export default "__VITE_ASSET__b4482924__"